// import React, { useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { toast } from 'react-toastify';
// import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     message: ''
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     // Store lead in localStorage
//     const leads = JSON.parse(localStorage.getItem('wisdom_leads') || '[]');
//     const newLead = {
//       ...formData,
//       calculatorType: 'Contact Form',
//       timestamp: new Date().toISOString()
//     };
//     leads.unshift(newLead);
//     localStorage.setItem('wisdom_leads', JSON.stringify(leads));

//     // Simulate email sending
//     setTimeout(() => {
//       toast.success('Message sent successfully! Our team will contact you shortly.');
//       setFormData({ name: '', email: '', phone: '', message: '' });
//       setIsSubmitting(false);
//     }, 1000);
//   };

//   const contactInfo = [
//     { icon: FaMapMarkerAlt, title: 'Visit Us', details: 'E-44, Vasant Vihar Society, GIDC -Vadsar Road, Vadodara-390010' },
//     { icon: FaPhone, title: 'Call Us', details: '9726344477, 9726766777', action: 'tel:9726344477' },
//     { icon: FaWhatsapp, title: 'WhatsApp', details: '9726344477', action: 'https://wa.me/9726344477' },
//     { icon: FaEnvelope, title: 'Email Us', details: 'Wisdom2secure@gmail.com', action: 'mailto:Wisdom2secure@gmail.com' },
//     { icon: FaClock, title: 'Working Hours', details: 'Mon-Sat: 10:00 AM - 7:00 PM\nSunday: Closed' },
//   ];

//   return (
//     <>
//       <Helmet>
//         <title>Contact Us - Wisdom Consultancy | Get Expert Financial Advice in Vadodara</title>
//         <meta name="description" content="Contact Wisdom Consultancy for expert financial advice, investment planning, and insurance solutions. Visit our office in Vadodara or call us today." />
//       </Helmet>

//       {/* Hero Section */}
//       <div className="bg-gradient-to-r from-primary to-secondary py-16">
//         <div className="container-custom text-center text-white">
//           <motion.h1
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="text-4xl md:text-5xl font-bold mb-4"
//           >
//             Contact Us
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.1 }}
//             className="text-xl opacity-90"
//           >
//             Get in touch with our financial experts
//           </motion.p>
//         </div>
//       </div>

//       {/* Contact Section */}
//       <section className="py-20 bg-gray-50">
//         <div className="container-custom">
//           <div className="grid lg:grid-cols-2 gap-12">
//             {/* Contact Form */}
//             <motion.div
//               initial={{ opacity: 0, x: -20 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               className="bg-white rounded-2xl shadow-xl p-8"
//             >
//               <h2 className="text-2xl font-bold text-primary mb-6">Send us a Message</h2>
//               <form onSubmit={handleSubmit} className="space-y-5">
//                 <div>
//                   <label className="block text-gray-700 font-semibold mb-2">Full Name *</label>
//                   <input
//                     type="text"
//                     required
//                     className="input-field"
//                     value={formData.name}
//                     onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//                     placeholder="Enter your full name"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-gray-700 font-semibold mb-2">Email Address *</label>
//                   <input
//                     type="email"
//                     required
//                     className="input-field"
//                     value={formData.email}
//                     onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//                     placeholder="Enter your email"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-gray-700 font-semibold mb-2">Phone Number *</label>
//                   <input
//                     type="tel"
//                     required
//                     className="input-field"
//                     value={formData.phone}
//                     onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//                     placeholder="Enter your mobile number"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-gray-700 font-semibold mb-2">Message *</label>
//                   <textarea
//                     required
//                     rows="5"
//                     className="input-field"
//                     value={formData.message}
//                     onChange={(e) => setFormData({ ...formData, message: e.target.value })}
//                     placeholder="Tell us about your financial needs..."
//                   />
//                 </div>

//                 <button
//                   type="submit"
//                   disabled={isSubmitting}
//                   className="w-full btn-primary py-3 disabled:opacity-50"
//                 >
//                   {isSubmitting ? 'Sending...' : 'Send Message'}
//                 </button>
//               </form>
//             </motion.div>

//             {/* Contact Info */}
//             <motion.div
//               initial={{ opacity: 0, x: 20 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               className="space-y-6"
//             >
//               <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-white">
//                 <h2 className="text-2xl font-bold mb-4">Get in Touch</h2>
//                 <p className="mb-6 opacity-90">Have questions? We're here to help. Reach out to us through any of these channels.</p>

//                 <div className="space-y-4">
//                   {contactInfo.map((info, idx) => (
//                     <div key={idx} className="flex gap-4">
//                       <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
//                         <info.icon size={18} />
//                       </div>
//                       <div>
//                         <h4 className="font-semibold">{info.title}</h4>
//                         {info.action ? (
//                           <a href={info.action} className="text-sm opacity-90 hover:opacity-100">
//                             {info.details}
//                           </a>
//                         ) : (
//                           <p className="text-sm opacity-90 whitespace-pre-line">{info.details}</p>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Social Links */}
//               <div className="bg-white rounded-2xl shadow-xl p-8">
//                 <h3 className="text-xl font-bold text-primary mb-4">Follow Us</h3>
               
// <div className="flex gap-4">
//   <a 
//     href="https://facebook.com" 
//     target="_blank" 
//     rel="noopener noreferrer" 
//     className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform"
//     aria-label="Facebook"
//   >
//     <FaFacebook size={20} />
//   </a>
//   <a 
//     href="https://twitter.com" 
//     target="_blank" 
//     rel="noopener noreferrer" 
//     className="w-12 h-12 bg-sky-500 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform"
//     aria-label="Twitter"
//   >
//     <FaTwitter size={20} />
//   </a>
//   <a 
//     href="https://linkedin.com" 
//     target="_blank" 
//     rel="noopener noreferrer" 
//     className="w-12 h-12 bg-blue-700 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform"
//     aria-label="LinkedIn"
//   >
//     <FaLinkedin size={20} />
//   </a>
//   <a 
//     href="https://instagram.com" 
//     target="_blank" 
//     rel="noopener noreferrer" 
//     className="w-12 h-12 bg-pink-600 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform"
//     aria-label="Instagram"
//   >
//     <FaInstagram size={20} />
//   </a>
//   <a 
//     href="https://wa.me/9726344477" 
//     target="_blank" 
//     rel="noopener noreferrer" 
//     className="w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform"
//     aria-label="WhatsApp"
//   >
//     <FaWhatsapp size={20} />
//   </a>
// </div>
//               </div>

//               {/* Map */}
//               <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
//                 <iframe
//                   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0!2d73.181!3d22.307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8e8b5b8b8b9%3A0x0!2zMjLCsDE4JzI1LjIiTiA3M8KwMTAnNTguNiJF!5e0!3m2!1sen!2sin!4v1699999999999!5m2!1sen!2sin"
//                   width="100%"
//                   height="250"
//                   style={{ border: 0 }}
//                   allowFullScreen=""
//                   loading="lazy"
//                   title="Wisdom Consultancy Location"
//                 ></iframe>
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Contact;
// import React, { useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { toast } from 'react-toastify';
// import {
//   FaMapMarkerAlt,
//   FaPhone,
//   FaEnvelope,
//   FaClock,
//   FaWhatsapp,
//   FaFacebook,
//   FaTwitter,
//   FaLinkedin,
//   FaInstagram,
// } from 'react-icons/fa';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     message: '',
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     const leads = JSON.parse(localStorage.getItem('wisdom_leads') || '[]');

//     const newLead = {
//       ...formData,
//       calculatorType: 'Contact Form',
//       timestamp: new Date().toISOString(),
//     };

//     leads.unshift(newLead);
//     localStorage.setItem('wisdom_leads', JSON.stringify(leads));

//     setTimeout(() => {
//       toast.success(
//         'Message sent successfully! Our team will contact you shortly.'
//       );

//       setFormData({
//         name: '',
//         email: '',
//         phone: '',
//         message: '',
//       });

//       setIsSubmitting(false);
//     }, 1000);
//   };

//   const contactInfo = [
//     {
//       icon: FaMapMarkerAlt,
//       title: 'Address',
//       details:
//         'E-44, Vasant Vihar Society, GIDC -Vadsar Road, Vadodara-390010',
//     },
//     {
//       icon: FaPhone,
//       title: 'Call Us',
//       details: '9726344477, 9726766777',
//       action: 'tel:9726344477',
//     },
//     {
//       icon: FaEnvelope,
//       title: 'Email',
//       details: 'wisdom2secure@gmail.com',
//       action: 'mailto:wisdom2secure@gmail.com',
//     },
//     {
//       icon: FaWhatsapp,
//       title: 'WhatsApp',
//       details: '9726344477',
//       action: 'https://wa.me/9726344477',
//     },
//     {
//       icon: FaClock,
//       title: 'Working Hours',
//       details: 'Mon - Sat : 10 AM - 7 PM',
//     },
//   ];

//   return (
//     <>
//       <Helmet>
//         <title>Contact Us - Wisdom Consultancy</title>
//       </Helmet>

//       <section className="relative overflow-hidden bg-[#f7f7f7] py-20">
//         {/* Grid Background */}
//         <div
//           className="absolute inset-0 opacity-40"
//           style={{
//             backgroundImage: `
//               linear-gradient(to right, #dcdcdc 1px, transparent 1px),
//               linear-gradient(to bottom, #dcdcdc 1px, transparent 1px)
//             `,
//             backgroundSize: '40px 40px',
//           }}
//         />

//         <div className="container-custom relative z-10">
//           {/* Heading */}
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             className="max-w-3xl mx-auto text-center mb-14"
//           >
//             <h1 className="text-4xl md:text-6xl font-extrabold leading-tight text-[#0b1c39]">
//               Get in{' '}
//               <span className="text-[#65c16f]">
//                 Touch
//               </span>{' '}
//               with Wisdom Consultancy
//             </h1>

//             <p className="mt-6 text-lg text-gray-600 leading-9">
//               Effortlessly connect with us using our simple inquiry form.
//               Share your details, and our team will respond promptly to assist
//               you.
//             </p>
//           </motion.div>

//           {/* Main Layout */}
//           <div className="grid lg:grid-cols-2 gap-10 items-start">
//             {/* Left Contact Card */}
//             <motion.div
//               initial={{ opacity: 0, x: -30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               className="bg-[#dfecef] rounded-[35px] p-8 md:p-10 shadow-lg"
//             >
//               <h2 className="text-3xl md:text-4xl font-bold text-[#0b1c39] leading-tight">
//                 Need <span className="text-[#3d63ff]">assistance?</span>
//               </h2>

//               <p className="text-3xl md:text-4xl font-bold text-[#0b1c39] mt-2 mb-10">
//                 We’re always a click away!
//               </p>

//               {/* Form */}
//               <form onSubmit={handleSubmit} className="space-y-5">
//                 <input
//                   type="text"
//                   required
//                   placeholder="Full Name"
//                   value={formData.name}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       name: e.target.value,
//                     })
//                   }
//                   className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
//                 />

//                 <input
//                   type="email"
//                   required
//                   placeholder="Email"
//                   value={formData.email}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       email: e.target.value,
//                     })
//                   }
//                   className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
//                 />

//                 <input
//                   type="tel"
//                   required
//                   placeholder="Phone Number"
//                   value={formData.phone}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       phone: e.target.value,
//                     })
//                   }
//                   className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
//                 />

//                 <textarea
//                   required
//                   rows="5"
//                   placeholder="Message"
//                   value={formData.message}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       message: e.target.value,
//                     })
//                   }
//                   className="w-full rounded-2xl px-6 py-5 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700 resize-none"
//                 />

//                 <button
//                   type="submit"
//                   disabled={isSubmitting}
//                   className="w-full h-16 rounded-2xl bg-[#0b1c39] text-white font-semibold text-lg hover:bg-[#132b57] transition-all duration-300"
//                 >
//                   {isSubmitting ? 'Sending...' : 'Send Message'}
//                 </button>
//               </form>
//             </motion.div>

//             {/* Right Contact Details */}
//             <motion.div
//               initial={{ opacity: 0, x: 30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               className="space-y-6"
//             >
//               {/* Info Cards */}
//               {contactInfo.map((info, idx) => (
//                 <div
//                   key={idx}
//                   className="bg-white rounded-3xl p-6 shadow-md hover:shadow-xl transition-all duration-300"
//                 >
//                   <div className="flex items-start gap-5">
//                     <div className="w-14 h-14 rounded-2xl bg-[#e8f5ea] flex items-center justify-center text-[#65c16f] text-xl flex-shrink-0">
//                       <info.icon />
//                     </div>

//                     <div>
//                       <h3 className="text-xl font-bold text-[#0b1c39] mb-1">
//                         {info.title}
//                       </h3>

//                       {info.action ? (
//                         <a
//                           href={info.action}
//                           target="_blank"
//                           rel="noreferrer"
//                           className="text-gray-600 hover:text-[#65c16f] transition-colors"
//                         >
//                           {info.details}
//                         </a>
//                       ) : (
//                         <p className="text-gray-600 leading-7">
//                           {info.details}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               ))}

//               {/* Social Links */}
//               <div className="bg-white rounded-3xl p-6 shadow-md">
//                 <h3 className="text-2xl font-bold text-[#0b1c39] mb-5">
//                   Follow Us
//                 </h3>

//                 <div className="flex flex-wrap gap-4">
//                   {[
//                     {
//                       icon: FaFacebook,
//                       link: 'https://facebook.com',
//                       bg: 'bg-blue-600',
//                     },
//                     {
//                       icon: FaTwitter,
//                       link: 'https://twitter.com',
//                       bg: 'bg-sky-500',
//                     },
//                     {
//                       icon: FaLinkedin,
//                       link: 'https://linkedin.com',
//                       bg: 'bg-blue-700',
//                     },
//                     {
//                       icon: FaInstagram,
//                       link: 'https://instagram.com',
//                       bg: 'bg-pink-500',
//                     },
//                     {
//                       icon: FaWhatsapp,
//                       link: 'https://wa.me/9726344477',
//                       bg: 'bg-green-500',
//                     },
//                   ].map((social, idx) => (
//                     <a
//                       key={idx}
//                       href={social.link}
//                       target="_blank"
//                       rel="noreferrer"
//                       className={`w-14 h-14 rounded-2xl ${social.bg} text-white flex items-center justify-center hover:scale-110 transition-transform duration-300`}
//                     >
//                       <social.icon size={22} />
//                     </a>
//                   ))}
//                 </div>
//               </div>

//               {/* Map */}
//               <div className="overflow-hidden rounded-3xl shadow-md">
//                 <iframe
//                   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0!2d73.181!3d22.307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8e8b5b8b8b9%3A0x0!2zMjLCsDE4JzI1LjIiTiA3M8KwMTAnNTguNiJF!5e0!3m2!1sen!2sin!4v1699999999999!5m2!1sen!2sin"
//                   width="100%"
//                   height="300"
//                   style={{ border: 0 }}
//                   allowFullScreen=""
//                   loading="lazy"
//                   title="Wisdom Consultancy Location"
//                 />
//               </div>
//             </motion.div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Contact;

import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaWhatsapp,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaGoogle,
} from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const leads = JSON.parse(localStorage.getItem('wisdom_leads') || '[]');

    const newLead = {
      ...formData,
      calculatorType: 'Contact Form',
      timestamp: new Date().toISOString(),
    };

    leads.unshift(newLead);
    localStorage.setItem('wisdom_leads', JSON.stringify(leads));

    setTimeout(() => {
      toast.success(
        'Message sent successfully! Our team will contact you shortly.'
      );

      setFormData({
        name: '',
        email: '',
        phone: '',
        message: '',
      });

      setIsSubmitting(false);
    }, 1000);
  };

  const contactInfo = [
    {
      icon: FaMapMarkerAlt,
      title: 'Address',
      details:
        'E-44, Vasant Vihar Society, GIDC -Vadsar Road, Vadodara-390010',
    },
    {
      icon: FaPhone,
      title: 'Call Us',
      details: '9726344477, 9726766777',
      action: 'tel:9726344477',
    },
    {
      icon: FaEnvelope,
      title: 'Email',
      details: 'wisdom2secure@gmail.com',
      action: 'mailto:wisdom2secure@gmail.com',
    },
    {
      icon: FaWhatsapp,
      title: 'WhatsApp',
      details: '9726344477',
      action: 'https://wa.me/919726344477',
    },
    {
      icon: FaClock,
      title: 'Working Hours',
      details: 'Mon - Sat : 10 AM - 7 PM',
    },
  ];

  return (
    <>
      <Helmet>
        <title>Contact Us - Wisdom Consultancy</title>
      </Helmet>

      <section className="relative overflow-hidden bg-[#f7f7f7] py-20">
        {/* Grid Background */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: `
              linear-gradient(to right, #dcdcdc 1px, transparent 1px),
              linear-gradient(to bottom, #dcdcdc 1px, transparent 1px)
            `,
            backgroundSize: '40px 40px',
          }}
        />

        <div className="container-custom relative z-10">
          {/* Heading */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto text-center mb-14"
          >
            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight text-[#0b1c39]">
              Get in{' '}
              <span className="text-[#65c16f]">
                Touch
              </span>{' '}
              with Wisdom Consultancy
            </h1>

            <p className="mt-6 text-lg text-gray-600 leading-9">
              Effortlessly connect with us using our simple inquiry form.
              Share your details, and our team will respond promptly to assist
              you.
            </p>
          </motion.div>

          {/* Main Layout */}
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            {/* Left Contact Card */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="bg-[#dfecef] rounded-[35px] p-8 md:p-10 shadow-lg"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-[#0b1c39] leading-tight">
                Need <span className="text-[#3d63ff]">assistance?</span>
              </h2>

              <p className="text-3xl md:text-4xl font-bold text-[#0b1c39] mt-2 mb-10">
                We’re always a click away!
              </p>

              {/* Form */}
              <form onSubmit={handleSubmit} className="space-y-5">
                <input
                  type="text"
                  required
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      name: e.target.value,
                    })
                  }
                  className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
                />

                <input
                  type="email"
                  required
                  placeholder="Email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      email: e.target.value,
                    })
                  }
                  className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
                />

                <input
                  type="tel"
                  required
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      phone: e.target.value,
                    })
                  }
                  className="w-full h-16 rounded-2xl px-6 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700"
                />

                <textarea
                  required
                  rows="5"
                  placeholder="Message"
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      message: e.target.value,
                    })
                  }
                  className="w-full rounded-2xl px-6 py-5 bg-white border border-transparent outline-none focus:border-[#65c16f] text-gray-700 resize-none"
                />

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full h-16 rounded-2xl bg-[#0b1c39] text-white font-semibold text-lg hover:bg-[#132b57] transition-all duration-300"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </motion.div>

            {/* Right Contact Details */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="space-y-6"
            >
              {/* Info Cards */}
              {contactInfo.map((info, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-3xl p-6 shadow-md hover:shadow-xl transition-all duration-300"
                >
                  <div className="flex items-start gap-5">
                    <div className="w-14 h-14 rounded-2xl bg-[#e8f5ea] flex items-center justify-center text-[#65c16f] text-xl flex-shrink-0">
                      <info.icon />
                    </div>

                    <div>
                      <h3 className="text-xl font-bold text-[#0b1c39] mb-1">
                        {info.title}
                      </h3>

                      {info.action ? (
                        <a
                          href={info.action}
                          target="_blank"
                          rel="noreferrer"
                          className="text-gray-600 hover:text-[#65c16f] transition-colors"
                        >
                          {info.details}
                        </a>
                      ) : (
                        <p className="text-gray-600 leading-7">
                          {info.details}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}

              {/* Social Links */}
              <div className="bg-white rounded-3xl p-6 shadow-md">
                <h3 className="text-2xl font-bold text-[#0b1c39] mb-5">
                  Follow Us
                </h3>

                <div className="flex flex-wrap gap-4">
                  {[
                    {
                      icon: FaFacebook,
                      link: 'https://www.facebook.com/profile.php?id=100091949229467',
                      bg: 'bg-blue-600',
                    },
                    {
                      icon: FaInstagram,
                      link: 'https://www.instagram.com/yags007/',
                      bg: 'bg-pink-500',
                    },
                    {
                      icon: FaYoutube,
                      link: 'https://www.youtube.com/@yagneshdole3378',
                      bg: 'bg-red-600',
                    },
                    {
                      icon: FaWhatsapp,
                      link: 'https://wa.me/919726344477',
                      bg: 'bg-green-500',
                    },
                    {
                      icon: FaGoogle,
                      link: 'https://share.google/BbsNaz8Fk9VqP3J1u',
                      bg: 'bg-yellow-500',
                    },
                  ].map((social, idx) => (
                    <a
                      key={idx}
                      href={social.link}
                      target="_blank"
                      rel="noreferrer"
                      className={`w-14 h-14 rounded-2xl ${social.bg} text-white flex items-center justify-center hover:scale-110 transition-transform duration-300`}
                    >
                      <social.icon size={22} />
                    </a>
                  ))}
                </div>
              </div>

              {/* Map */}
              <div className="overflow-hidden rounded-3xl shadow-md">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0!2d73.181!3d22.307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8e8b5b8b8b9%3A0x0!2zMjLCsDE4JzI1LjIiTiA3M8KwMTAnNTguNiJF!5e0!3m2!1sen!2sin!4v1699999999999!5m2!1sen!2sin"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Wisdom Consultancy Location"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;